import { Component, ElementRef, OnInit, ViewChildren } from "@angular/core";
import { Development } from "@models/development.model";
import { DropDown } from "@models/project.model";
import { CityBoroughService } from "@services/city-borough.service";
import { DevelopmentService } from "@services/development.service";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit {
  mapZoomLevel = 10;
  searchValue = "";
  developmentList: Development[] = [];
  filteredDevelopmentList: Development[] = [];
  selectedDevelopment: Development | undefined = undefined;
  developmentName = "";
  projectId = "0";
  centeredMap!: Array<number>;

  selectedProjectStatus: DropDown[] = [];

  boroughList: DropDown[] = [
    {
      id: "selectAllBorough",
      label: "Select All",
      checked: true,
    },
    {
      id: "bronx",
      label: "Bronx",
      checked: true,
    },
    {
      id: "brooklyn",
      label: "Brooklyn",
      checked: true,
    },
    {
      id: "manhattan",
      label: "Manhattan",
      checked: true,
    },
    {
      id: "queens",
      label: "Queens",
      checked: true,
    },
    {
      id: "statenIsland",
      label: "Staten Island",
      checked: true,
    },
  ];
  councilDistrictList: DropDown[] = [
    {
      id: "selectAllDistricts",
      label: "Select All",
      checked: true,
    },
  ];
  fundingSourceList: DropDown[] = [
    {
      id: "selectAllFunding",
      label: "Select All",
      checked: true,
    },
    { id: "city", label: "City", checked: true },
    { id: "federal", label: "Federal", checked: true },
    { id: "state", label: "State", checked: true },
    { id: "other", label: "Other", checked: true },
  ];
  projectStatusList: DropDown[] = [
    {
      id: "selectAllStatus",
      label: "Select All",
      checked: true,
    },
    {
      id: "completed",
      label: "Completed",
      checked: true,
    },
    {
      id: "active",
      label: "Active",
      checked: true,
    },
    {
      id: "onHold",
      label: "On Hold",
      checked: true,
    },
    {
      id: "planned",
      label: "Planned",
      checked: true,
    },
  ];

  @ViewChildren("developmentSummary") developmentSummary?: ElementRef;

  constructor(
    private developmentService: DevelopmentService,
    private cityBoroughService: CityBoroughService,
  ) {}

  ngOnInit(): void {
    this.developmentList = this.developmentService
      .getItems()
      .sort((a, b) => a.name.localeCompare(b.name));
    this.filteredDevelopmentList = this.developmentService.getItems();

    // console.log("DevelopmentList", this.developmentList);

    this.fillDistrict();

    try {
      const link = document.querySelector(".language-selector a") as HTMLAnchorElement;
      if (link) {
        link.href = `${window.location}#`;
      }
    } catch (error) {
      console.log(error);
    }
  }

  private fillDistrict() {
    for (let i = 0; i < 51; ++i) {
      this.councilDistrictList.push({
        id: `district${i + 1}`,
        label: (i + 1).toString(),
        checked: true,
      });
    }
  }

  /**
   * @description Fires up when the map is loaded
   * @param {boolean} status
   */
  mapLoadedEvent(status: boolean) {
    console.log("The map loaded: " + status);
  }

  /**
   * @description Loads a development based on its ID
   * @param {string} development
   */
  loadDevelopmentSummary(developmentId: number) {
    this.moveCursorToLocation();
    this.selectedDevelopment = this.developmentList.find((item) => item.id == developmentId);
    this.selectedProjectStatus = [];
    this.selectedProjectStatus = this.projectStatusList.filter((x) => x.checked == true);

    if (!this.selectedDevelopment) {
      console.log("selectedDevelopment:", this.selectedDevelopment);
    }
  }

  /**
   * @description Filters out the list of developments
   * @param {string} inputValue the keyword to look for
   */
  searchDevelopment(inputValue: string): void {
    this.moveCursorToLocation();
    this.selectedDevelopment = this.developmentList.find(
      (development) => inputValue.toLocaleLowerCase() == development.name.toLocaleLowerCase(),
    );
    this.selectedProjectStatus = [];
    this.selectedProjectStatus = this.projectStatusList.filter((x) => x.checked == true);

    this.filteredDevelopmentList = this.filterDevelopments(inputValue);
  }

  private moveCursorToLocation() {
    if (screen.width < 500) {
      const developmentSummary = document.getElementById("development-summary-id");
      const noDevelopmentSelected = document.getElementById("no-development-selected-id");
      if (this.selectedDevelopment) {
        if (developmentSummary) {
          window.scrollTo({ top: developmentSummary?.offsetTop - 10, behavior: "smooth" });
        }
      } else {
        if (noDevelopmentSelected) {
          window.scrollTo({ top: noDevelopmentSelected?.offsetTop - 10, behavior: "smooth" });
        }
      }
    }
  }

  /**
   * @description Closes the development summary
   */
  closeModal(): void {
    this.selectedDevelopment = undefined;
  }

  /**
   * @description Resets all filters
   */
  resetFilters(): void {
    this.searchValue = "";
    this.selectedDevelopment = undefined;
    this.boroughList.forEach((borough) => (borough.checked = true));
    this.councilDistrictList = [
      {
        id: "selectAllDistricts",
        label: "Select All",
        checked: true,
      },
    ];
    this.fillDistrict();
    //this.councilDistrictList.forEach((district) => (district.checked = true));
    this.fundingSourceList.forEach((funding) => (funding.checked = true));
    this.projectStatusList.forEach((status) => (status.checked = true));
    this.filteredDevelopmentList = this.filterDevelopments("");
  }

  checkDropDown(dropDownName: string, dropDown: DropDown): void {
    dropDown.checked = !dropDown.checked;

    const bronx = [-73.873896, 40.856216];
    const brooklyn = [-73.943186, 40.655938];
    const manhattan = [-73.961415, 40.789484];
    const queens = [-73.827244, 40.716651];
    const statenIsland = [-74.158893, 40.571259];

    switch (dropDownName) {
      case "borough":
        if (dropDown.label == "Select All") {
          this.boroughList.forEach((borough) => (borough.checked = dropDown.checked));

          if (dropDown.checked) {
            this.centeredMap = [-73.95, 40.726];
          }
        } else if (dropDown.checked) {
          switch (dropDown.id) {
            case "bronx":
              this.centeredMap = bronx;
              break;
            case "brooklyn":
              this.centeredMap = brooklyn;
              break;
            case "manhattan":
              this.centeredMap = manhattan;
              break;
            case "queens":
              this.centeredMap = queens;
              break;
            case "statenIsland":
              this.centeredMap = statenIsland;
              break;
          }
        }

        this.councilDistrictList = [
          {
            id: "selectAllDistricts",
            label: "Select All",
            checked: true,
          },
        ];

        if (!this.boroughList.every((x) => x.checked === false)) {
          this.boroughList.forEach((borough) => {
            const boroughList = this.cityBoroughService
              .getItems()
              .filter(
                (x) =>
                  x.borough.toLocaleLowerCase() === borough.label.toLocaleLowerCase() &&
                  borough.checked === true,
              );

            boroughList.forEach((item) => {
              this.councilDistrictList.push({
                id: `district${item.cityCouncilDistrict}`,
                label: item.cityCouncilDistrict.toString(),
                checked: true,
              });
            });
          });

          this.cityBoroughService
            .getItems()
            .filter((x) => x.borough.includes(","))
            .forEach((item) => {
              item.borough.split(",").forEach((boroughItem) => {
                this.boroughList.forEach((borough) => {
                  if (
                    borough.label.toLocaleLowerCase() === boroughItem.trim().toLocaleLowerCase() &&
                    borough.checked === true
                  ) {
                    if (
                      !this.councilDistrictList.find(
                        (x) => x.id === `district${item.cityCouncilDistrict}`,
                      )
                    ) {
                      this.councilDistrictList.push({
                        id: `district${item.cityCouncilDistrict}`,
                        label: item.cityCouncilDistrict.toString(),
                        checked: true,
                      });
                    }
                  }
                });
              });
            });

          this.councilDistrictList = this.councilDistrictList.sort(
            (a, b) => parseInt(a.label) - parseInt(b.label),
          );
        } else {
          this.fillDistrict();
        }

        if (!dropDown.checked) {
          if (dropDown.id !== "selectAllBorough") {
            this.boroughList.forEach((borough) => {
              if (borough.id === "selectAllBorough") {
                borough.checked = false;
              }
            });
          }
        }

        if (this.boroughList.filter((x) => x.id !== "selectAllBorough").every((x) => x.checked)) {
          this.boroughList.forEach((borough) => {
            if (borough.id === "selectAllBorough") {
              borough.checked = true;
            }
          });
        }
        break;
      case "district":
        if (dropDown.label == "Select All") {
          this.councilDistrictList.forEach((district) => (district.checked = dropDown.checked));

          if (dropDown.checked) {
            this.centeredMap = [-73.95, 40.726];
          }
        } else if (dropDown.checked) {
          const borough = this.developmentList.find(
            (d) => parseInt(d.district) == parseInt(dropDown.label),
          )?.borough;

          switch (borough) {
            case "BRONX":
              this.centeredMap = bronx;
              break;
            case "BROOKLYN":
              this.centeredMap = brooklyn;
              break;
            case "MANHATTAN":
              this.centeredMap = manhattan;
              break;
            case "QUEENS":
              this.centeredMap = queens;
              break;
            case "STATEN ISLAND":
              this.centeredMap = statenIsland;
              break;
          }
        }
        if (!dropDown.checked) {
          if (dropDown.id !== "selectAllDistricts") {
            this.councilDistrictList.forEach((district) => {
              if (district.id === "selectAllDistricts") {
                district.checked = false;
              }
            });
          }
        }
        if (
          this.councilDistrictList
            .filter((x) => x.id !== "selectAllDistricts")
            .every((x) => x.checked)
        ) {
          this.councilDistrictList.forEach((district) => {
            if (district.id === "selectAllDistricts") {
              district.checked = true;
            }
          });
        }
        break;
      case "funding":
        if (dropDown.label == "Select All") {
          this.fundingSourceList.forEach((funding) => (funding.checked = dropDown.checked));
        }

        if (!dropDown.checked) {
          if (dropDown.id !== "selectAllFunding") {
            this.fundingSourceList.forEach((funding) => {
              if (funding.id === "selectAllFunding") {
                funding.checked = false;
              }
            });
          }
        }
        if (
          this.fundingSourceList.filter((x) => x.id !== "selectAllFunding").every((x) => x.checked)
        ) {
          this.fundingSourceList.forEach((funding) => {
            if (funding.id === "selectAllFunding") {
              funding.checked = true;
            }
          });
        }
        break;
      case "status":
        if (dropDown.label == "Select All") {
          this.projectStatusList.forEach((status) => (status.checked = dropDown.checked));
        }

        if (!dropDown.checked) {
          if (dropDown.id !== "selectAllStatus") {
            this.projectStatusList.forEach((status) => {
              if (status.id === "selectAllStatus") {
                status.checked = false;
              }
            });
          }
        }
        if (
          this.projectStatusList.filter((x) => x.id !== "selectAllStatus").every((x) => x.checked)
        ) {
          this.projectStatusList.forEach((status) => {
            if (status.id === "selectAllStatus") {
              status.checked = true;
            }
          });
        }
        break;
    }

    this.filteredDevelopmentList = this.filterDevelopments(this.searchValue);
  }

  /**
   * @description Filters the developments based on a keyword.
   * @param {string} keyword the word/s to search for.
   * @returns {*}  {Development[]} An array of developments.
   */
  filterDevelopments(keyword: string): Development[] {
    if (
      !keyword.trim().length &&
      this.boroughList[0].checked &&
      this.councilDistrictList[0].checked &&
      this.fundingSourceList[0].checked &&
      this.projectStatusList[0].checked
    ) {
      return this.developmentList;
    }

    return this.developmentList
      .filter((development: Development) => {
        let found = false;

        if (this.boroughList[0].checked || !this.boroughList.filter((d) => d.checked).length) {
          return true;
        }

        for (const borough of this.boroughList.filter((d) => d.checked)) {
          if (development.borough == borough.label.toUpperCase()) {
            found = true;
            break;
          }
        }

        return found;
      })
      .filter((development: Development) => {
        let found = false;

        if (
          this.councilDistrictList[0].checked ||
          !this.councilDistrictList.filter((d) => d.checked).length
        ) {
          return true;
        }

        for (const district of this.councilDistrictList.filter((d) => d.checked)) {
          if (development.district.split(",").length > 1) {
            development.district.split(",").forEach((x) => {
              if (parseInt(x ?? 0) === parseInt(district.label) && district.checked) {
                // console.log(development.district);
                found = true;
              }
            });
            break;
          } else if (
            parseInt(development.district ?? 0) === parseInt(district.label) &&
            district.checked
          ) {
            // console.log(development.district);
            found = true;
            break;
          }
        }

        return found;
      })
      .filter((development: Development) => {
        let found = false;
        const projects = development.areasOfWork.map((areaOfWork) => areaOfWork.projects).flat();

        if (
          this.fundingSourceList[0].checked ||
          !this.fundingSourceList.filter((d) => d.checked).length
        ) {
          return true;
        }

        for (const funding of this.fundingSourceList.filter((d) => d.checked)) {
          if (
            projects.filter((p) => {
              return p.funding.filter((f) => f.fundingCategory == funding.label).length > 0;
            }).length > 0
          ) {
            found = true;
            break;
          }
        }

        return found;
      })
      .filter((development: Development) => {
        let found = false;
        const projects = development.areasOfWork.map((areaOfWork) => areaOfWork.projects).flat();

        if (
          this.projectStatusList[0].checked ||
          !this.projectStatusList.filter((d) => d.checked).length
        ) {
          return true;
        }

        for (const status of this.projectStatusList.filter((d) => d.checked)) {
          // if (
          //   projects.filter((p) => {
          //     return (
          //       p.schedule.filter((schedule) => schedule.projectStatus == status.label).length > 0
          //     );
          //   }).length > 0
          // ) {
          //   found = true;
          //   break;
          // }
          if (
            projects.filter((p) => {
              return p.projectStatus == status.label;
            }).length > 0
          ) {
            found = true;
            break;
          }
        }

        return found;
      })
      .filter((development: Development) => {
        if (!keyword.trim().length) {
          return true;
        }

        const words = keyword.toLowerCase().split(" ");
        let found = false;

        for (const word of words) {
          if (development.name.toLowerCase().includes(word)) {
            found = true;
            break;
          }
        }

        return found;
      });
  }
}
